import { message } from "antd";
import { t } from "i18next";
import i18n from "../shared/i18n";

export const makeStringId = (length: number) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const calculateEvaluated = (evaluatedRate: number) => {
  if (evaluatedRate <= 20) {
    return "red";
  } else if (evaluatedRate >= 21 && evaluatedRate <= 40) {
    return "yellow";
  } else if (evaluatedRate >= 41 && evaluatedRate <= 60) {
    return "orange";
  } else if (evaluatedRate >= 61 && evaluatedRate <= 80) {
    return "success";
  } else if (evaluatedRate >= 81 && evaluatedRate <= 100) {
    return "green";
  } else {
    return;
  }
};

const colors = ["red", "green", "orange", "blue"];

export const getProfileRandomColor = () => {
  const randomIndex = Math.floor(Math.random() * colors.length);
  const randomItem = colors[randomIndex];
  return randomItem;
};

export const EMPTY_GUID_VALUE = "00000000-0000-0000-0000-000000000000";

export const PhoneNumberRegexRule = (t) => ({
  // pattern: new RegExp(/^(\+\d{1,3}[- ]?)?\d{10}$/i),
  pattern: new RegExp(/^[0-9() ]*$/i),
  message: t("error.ValidNumber"),
});

export const formatterNumberInput = (value) => {
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const parserNumberInput = (value) => {
  return value.replace(/\$\s?|(,*)/g, "");
};

export const numberPipeline = (value: number) => {
  return value.toLocaleString();
};

export const setTabPosition = (windowSize) => {
  switch (windowSize) {
    case "xxl":
      return i18n.dir() === "ltr" ? "left" : "right";
    case "xl":
      return i18n.dir() === "ltr" ? "left" : "right";
    case "lg":
      return i18n.dir() === "ltr" ? "left" : "right";
    case "md":
      return "top";
    case "sm":
      return "top";
    case "xs":
      return "top";
    default:
      return i18n.dir() === "ltr" ? "left" : "right";
  }
};

const interviewColors = [
  "rgba(255, 148, 79, 1)",
  "rgba(81, 143, 255, 1)",
  "rgba(212, 144, 255, 1)",
  "rgba(240, 200, 39, 1)",
  "rgba(122, 188, 63, 1)",
  "rgba(143, 178, 244, 1)",
  "rgba(227, 119, 162, 1)",
  "rgba(94, 225, 203, 1)",
  "rgba(255, 113, 130, 1)",
];

export const makeRandomColor = (index: number) => {
  const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
  return color;
};

export const renderColor = ({ colors = interviewColors, index }) => {
  if (index + 1 > colors.length) {
    index = index % colors.length;
  }
  return colors[index];
};

const RESERVED_SUBDOMAINS = new Set([
  "www",
  "api",
  "admin",
  "app",
  "static",
  "cdn",
]);
const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "0.0.0.0", "[::1]"]);

/**
 * Returns the tenant subdomain from the current host, or null when there is none.
 */
export const getSubdomain = (): string | null => {
  const host = window.location.hostname.toLowerCase();
  const parts = host.split(".");

  // Localhost or IP address -> no subdomain
  if (LOCAL_HOSTNAMES.has(host) || parts.length < 3) {
    return null;
  }

  // Reject numeric IPs (e.g. "10.0.0.1")
  if (parts.every((p) => /^\d+$/.test(p))) {
    return null;
  }

  const candidate = parts.slice(0, -2).join(".");
  const labels = candidate.split(".");

  if (labels[0] && RESERVED_SUBDOMAINS.has(labels[0])) {
    const stripped = labels.slice(1).join(".");
    return stripped.length > 0 ? stripped : null;
  }

  return candidate;
};

export const buildTenantUrl = (path: string): string => {
  const baseUrl = `${(
    window._env_?.VITE_BASE_API_URL || import.meta.env.VITE_BASE_API_URL
  ).replace("/meet/api", "")}`;

  // strip leading slash from path; we'll add our own
  const cleanPath = path.replace(/^\/+/, "");

  return `${baseUrl.replace(/\/+$/, "")}/${cleanPath}`;
};

export const openTaskUrl = (taskUrl: string) => {
  const url = buildTenantUrl(taskUrl);
  window.open(url, "_blank");
};

export const removeNullProperties = (obj) => {
  const newObj = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value !== null) {
      newObj[key] = value;
    }
  }
  return newObj;
};
export const generateAddress = (data) => {
  let newAddress = "";
  if (data.address) {
    // if (data.address.county) {
    //   newAddress += data.address.country;
    //   newAddress += ", ";
    // }
    // if (data.address.city) {
    //   newAddress += data.address.city;
    //   newAddress += ", ";
    // }
    if (data.address.neighbourhood) {
      newAddress += data.address.neighbourhood;
      newAddress += ", ";
    }
    if (data.address.road) {
      newAddress += data.address.road;
      newAddress += ", ";
    }
    if (newAddress !== "") {
      newAddress = newAddress.substring(0, newAddress.length - 2);
    }
  } else {
    return "";
  }
  return newAddress;
};

export const validateInputField = (rule, value) => {
  if (value && value.trim() === "") {
    return Promise.reject(t("error.validText"));
  }
  return Promise.resolve();
};
export const convertToQuarters = () => {
  const options = [];

  for (let minutes = 15; minutes <= 1440; minutes += 15) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const label = `${hours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}`;
    options.push({ value: minutes, label });
  }

  return options;
};
export const setButtonSize = (windowSize: string) => {
  if (windowSize === "xs" || windowSize === "sm" || windowSize === "md") {
    return "small";
  } else {
    return "middle";
  }
};

export const copyToClipboard = (result) => {
  // copy the link to clipboard
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard
      .writeText(result)
      .then(() => {
        message.success(t("notification.copiedLink"));
      })
      .catch((err) => {
        console.error("Failed to copy the link: ", err);
      });
  } else {
    // fallback method for non-secure contexts (non http)
    const textArea = document.createElement("textarea");
    textArea.value = result;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      message.success(t("notification.copiedLink"));
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
  }
};
